export class CommunityDashboardReportAccessResultDto {
    allowExpenses: boolean;
    allowOpenViolations: boolean;
    allowAccountsStanding: boolean;
    allowCashInvestment: boolean;
}
